/**
 * 浏览器兼容性polyfill
 */

interface MyPromise {
  then: (onFulfilled?: (value: any) => any, onRejected?: (reason: any) => any) => MyPromise;
  catch: (onRejected?: (reason: any) => any) => MyPromise;
}

// Promise polyfill
if (typeof Promise === 'undefined') {
  // @ts-ignore
  window.Promise = function(executor: (resolve: (value: any) => void, reject: (reason: any) => void) => void): MyPromise {
    const resolveCallbacks: Array<(value: any) => any> = [];
    const rejectCallbacks: Array<(reason: any) => any> = [];
    let state = 'pending';
    let value: any;
    let reason: any;

    function resolve(val: any) {
      if (state === 'pending') {
        state = 'fulfilled';
        value = val;
        resolveCallbacks.forEach(fn => fn(value));
      }
    }

    function reject(err: any) {
      if (state === 'pending') {
        state = 'rejected';
        reason = err;
        rejectCallbacks.forEach(fn => fn(reason));
      }
    }

    try {
      executor(resolve, reject);
    } catch (e) {
      reject(e);
    }

    return {
      then: function(onFulfilled?: (value: any) => any, onRejected?: (reason: any) => any): MyPromise {
        if (state === 'fulfilled' && typeof onFulfilled === 'function') {
          onFulfilled(value);
        } else if (state === 'rejected' && typeof onRejected === 'function') {
          onRejected(reason);
        } else if (state === 'pending') {
          if (typeof onFulfilled === 'function') {
            resolveCallbacks.push(onFulfilled);
          }
          if (typeof onRejected === 'function') {
            rejectCallbacks.push(onRejected);
          }
        }
        return this;
      },
      catch: function(onRejected?: (reason: any) => any): MyPromise {
        if (state === 'rejected' && typeof onRejected === 'function') {
          onRejected(reason);
        } else if (state === 'pending' && typeof onRejected === 'function') {
          rejectCallbacks.push(onRejected);
        }
        return this;
      },
    };
  };
}

// Object.assign polyfill
if (typeof Object.assign !== 'function') {
  // @ts-ignore
  Object.assign = function(target) {
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }
    const to = Object(target);
    for (let i = 1; i < arguments.length; i++) {
      const nextSource = arguments[i];
      if (nextSource != null) {
        for (const nextKey in nextSource) {
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

// Array.from polyfill
if (!Array.from) {
  // @ts-ignore
  Array.from = function(arrayLike) {
    const arr: any[] = [];
    for (const item of arrayLike) {
      arr.push(item);
    }
    return arr;
  };
}

// Element.classList polyfill (简化版)
if (!('classList' in document.documentElement)) {
  Object.defineProperty(HTMLElement.prototype, 'classList', {
    get: function() {
      const self = this;
      function update(fn) {
        return function(value) {
          const classes = self.className.split(/\s+/);
          fn(classes, value);
          self.className = classes.join(' ');
          return self;
        };
      }

      return {
        add: update(function(classes, value) {
          if (classes.indexOf(value) < 0) {
            classes.push(value);
          }
        }),
        remove: update(function(classes, value) {
          const index = classes.indexOf(value);
          if (index >= 0) {
            classes.splice(index, 1);
          }
        }),
        toggle: update(function(classes, value) {
          const index = classes.indexOf(value);
          if (index >= 0) {
            classes.splice(index, 1);
          } else {
            classes.push(value);
          }
        }),
        contains: function(value) {
          return self.className.split(/\s+/).indexOf(value) >= 0;
        },
      };
    },
  });
}

// 为较老版本的Safari添加requestAnimationFrame支持
if (!window.requestAnimationFrame) {
  // @ts-ignore
  window.requestAnimationFrame = function(callback) {
    return setTimeout(function() {
      callback(Date.now());
    }, 1000 / 60);
  };
}

if (!window.cancelAnimationFrame) {
  // @ts-ignore
  window.cancelAnimationFrame = function(id) {
    clearTimeout(id);
  };
}
